export default __webpack_public_path__ + "6d6b162a37a4533135769b226dd34d6a.png";